import React from 'react';
import {
  Button,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import Icon from '@mdi/react';
import { mdiChevronDown, mdiArrowRight, mdiArrowLeft } from '@mdi/js';
import { PAGE_SIZE } from './constant';

import './TablePagination.scss';

function TablePagination({
  nextPage,
  prevPage,
  totalPages,
  currentPage,
  hasNextPage,
  hasPreviousPage,
  totalCount,
  getPageSize,
  setPageSize,
  children,
}) {
  const buttonStyle = {
    backgroundColor: '#ffffff',
    border: '1px solid #D0D5DD',
    padding: '0.2rem 0.5rem',
    width: '36px',
    height: '36px',
    fontSize: '0.75rem',
    cursor: 'pointer',
    borderRadius: '8px',
    boxShadow: '0px 1px 2px 0px #1018280D;',
  };

  const pageSize = getPageSize();
  const start = totalCount === 0 ? 0 : (currentPage - 1) * pageSize + 1;
  const end = Math.min(currentPage * pageSize, totalCount);

  return (
    <div className="d-flex justify-content-between align-items-center table-pagination">
      <div className="d-flex align-items-center gap-2">
        <UncontrolledDropdown as="div">
          <DropdownToggle
            className="table-pagination-dropdown-toggle d-flex align-items-center"
            as="span"
          >
            <span>{getPageSize()}</span>
            <Icon
              path={mdiChevronDown}
              size={0.8}
              style={{ color: '#026aa2' }}
            />
          </DropdownToggle>
          <DropdownMenu className="p-2">
            {PAGE_SIZE?.map(option => (
              <DropdownItem
                className="status-option mb-2 py-2"
                as="span"
                key={option}
                onClick={() => setPageSize(option)}
                active={getPageSize() === option}
              >
                {option}
              </DropdownItem>
            ))}
          </DropdownMenu>
        </UncontrolledDropdown>
        <span className="table-pagination-info">
          {start || 0} – {end || 0} out of {totalCount || 0} entries
        </span>
      </div>
      <div>{children || null}</div>
      <div className="d-flex gap-2">
        <Button
          type="Button"
          style={{
            ...buttonStyle,
            color: hasPreviousPage ? '#000000' : '#A1A1A1',
            opacity: hasPreviousPage ? 1 : 0.5,
          }}
          onClick={prevPage}
          disabled={!hasPreviousPage}
        >
          <Icon path={mdiArrowLeft} size={0.8} style={{ color: '#344054' }} />
        </Button>
        <div className="d-flex align-items-center gap-2">
          <div>
            Page
            <span className="px-1 fw-bold">{totalPages ? currentPage : 0}</span>
            of
            <span className="px-1 fw-bold">{totalPages || 0}</span>
          </div>
        </div>
        <Button
          type="Button"
          style={{
            ...buttonStyle,
            color: hasNextPage ? '#000000' : '#A1A1A1',
            opacity: hasNextPage ? 1 : 0.5,
          }}
          onClick={nextPage}
          disabled={!hasNextPage}
        >
          <Icon path={mdiArrowRight} size={0.8} style={{ color: '#344054' }} />
        </Button>
      </div>
    </div>
  );
}

export default TablePagination;
